import { createSelector } from 'reselect';

import getCognitoUser from '../getCognitoUser';
import getUsersById from '../getUsersById';

/**
 * Returns the 'service-provider-users' data model for the app user.
 */
const getAppUser = createSelector(
  [getCognitoUser, getUsersById],
  (cognitoUser, usersById) => {
    if(cognitoUser != null) return usersById[cognitoUser.username]
  }
);

export default getAppUser;